export default __webpack_public_path__ + "static/media/explore_hubs_pers.31901dd8.svg";